import React, { createContext, useContext, useState } from "react";

const NewsletterContext = createContext();

export const NewsletterProvider = ({ children }) => {
  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(false);
  const [showPrivacyError, setShowPrivacyError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!checked) {
      setShowPrivacyError(true);
      return;
    }

    setShowPrivacyError(false);
    setError("");
    setIsSubmitting(true);

    try {
      const response = await window.newsletterSubscribeNew(email);
      
      if (response.success) {
        setIsSuccess(true);
        setEmail("");
        setChecked(false);
      } else {
        setError(response.error || "Error al suscribirse");
      }
    } catch (err) {
      setError("Error al suscribirse. Por favor, inténtelo de nuevo.");
      console.error("Error subscribing to newsletter:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <NewsletterContext.Provider
      value={{
        email,
        setEmail,
        checked,
        setChecked,
        showPrivacyError,
        setShowPrivacyError,
        isSubmitting,
        isSuccess,
        error,
        handleSubmit,
      }}
    >
      {children}
    </NewsletterContext.Provider>
  );
};

export const useNewsletter = () => {
  const context = useContext(NewsletterContext);
  if (!context) {
    throw new Error("useNewsletter must be used within a NewsletterProvider");
  }
  return context;
}; 